import { LegalPage } from "@/components/legal/LegalPage";
import { COMPANY } from "@/lib/company";

export default function Cookies() {
  return (
    <LegalPage title="Politica de cookies" updated="iunie 2026">
      <h2>1. Ce sunt cookie-urile</h2>
      <p>
        Cookie-urile sunt fișiere text de mici dimensiuni stocate pe dispozitivul dumneavoastră atunci când vizitați
        un website. Ele ajută site-ul să funcționeze corect și să rețină anumite preferințe.
      </p>

      <h2>2. Ce cookie-uri folosim</h2>
      <ul>
        <li><strong>Cookie-uri strict necesare:</strong> permit funcționarea coșului de cumpărături și a site-ului;</li>
        <li><strong>Cookie-uri funcționale:</strong> rețin preferințe (ex: conținutul coșului este salvat local în browser);</li>
        <li><strong>Cookie-uri de analiză:</strong> ne ajută să înțelegem modul de utilizare a site-ului (dacă sunt activate).</li>
      </ul>

      <h2>3. Gestionarea cookie-urilor</h2>
      <p>
        Puteți controla și șterge cookie-urile din setările browserului dumneavoastră. Dezactivarea anumitor
        cookie-uri poate afecta funcționalitatea site-ului (de exemplu, salvarea coșului).
      </p>

      <h2>4. Contact</h2>
      <p>
        Pentru întrebări privind utilizarea cookie-urilor, ne puteți contacta la {COMPANY.email} sau {COMPANY.phone}.
        Operator: {COMPANY.legalName}, CUI {COMPANY.cui}.
      </p>
    </LegalPage>
  );
}
